import type { EmailPulseDataRow } from '../reports-service.types';

/**
 * Type for the metric-only fields of EmailPulseDataRow.
 * These are the numeric string fields shared across all tabs.
 */
type MetricValues = Omit<
  EmailPulseDataRow,
  | 'id'
  | 'messageId'
  | 'offerId'
  | 'messageTitle'
  | 'offerTitle'
  | 'emailType'
  | 'emailTypeDisplay'
>;

/**
 * Default values for all 19 metric fields.
 * Used by createDataRow and createTotalRow to avoid
 * repeating every field in each fixture row.
 */
export const DEFAULT_METRIC_VALUES: MetricValues = {
  sent: '0',
  delivered: '0',
  deliveryRate: '0%',
  emailsBounced: '0',
  emailsDropped: '0',
  emailsOpened: '0',
  uniqueOpens: '0',
  clicks: '0',
  uniqueClicks: '0',
  clickThroughRate: '0%',
  unsubscribes: '0',
  spamReports: '0',
  spamReportRate: '0%',
  openRate: '0%',
  clickRate: '0%',
  bounceRate: '0%',
  unsubscribeRate: '0%',
  emailsDeferred: '0',
  uniqueEmailsDeferred: '0',
};

/**
 * Creates a complete EmailPulseDataRow with defaults for any unspecified metric fields.
 * The `id` field is required in overrides.
 */
export const createDataRow = (
  overrides: Partial<EmailPulseDataRow> & { id: string },
): EmailPulseDataRow => ({
  ...DEFAULT_METRIC_VALUES,
  ...overrides,
});

/**
 * Creates a total row (metrics only, no identifier fields).
 * Used for the `total` property of EmailPulseDataResponse.
 */
export const createTotalRow = (
  overrides: Partial<MetricValues>,
): MetricValues => ({
  ...DEFAULT_METRIC_VALUES,
  ...overrides,
});
